import { CommonModule, DatePipe, NgFor, NgIf } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'
import { ActivatedRoute, RouterLink } from '@angular/router'
import { BusinessOwnerService } from '../../../../services/business-owner.service'
import { BusinessService } from '../../../../services/business.service'
import { OfficeService } from '../../../../services/office.service'
import { CountryService } from '../../../../services/country.service'
import { StateService } from '../../../../services/state.service'
import { CityService } from '../../../../services/city.service'
import { UserService } from '../../../../services/user.service'
import { environment } from '../../../../../environments/environment'
import { eps } from '../../../../services/url.service'
import { AuthService } from '../../../../services/auth.service'
import { User } from '../../../../store/auth/auth.state'
import { Location } from '@angular/common'
import { City } from '../../../../store/city/city.state'
import { Office } from '../../../../store/office/office.state'
import { SharedModule } from '../../../../shared/shared.module'
import { Store } from '@ngrx/store'
import { loadEmployees } from '../../../../store/user/user.actions'
import { distinctUntilChanged, map, Observable, tap } from 'rxjs'
import { selectAllUsers, selectTotalCount } from '../../../../store/user/user.selectors'

@Component({
  selector: 'app-office-details',
  imports: [
    DatePipe,
    RouterLink,
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CapitalizePipe,
    HasPermissionDirective,
    PaginationComponent,
    SharedModule
  ],
  templateUrl: './office-details.component.html',
  styleUrl: './office-details.component.scss'
})
export class OfficeDetailsComponent implements OnInit {
  private store = inject(Store) // Inject store using `inject()`
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  toastr = inject(ToastrService)
  eps = eps
  public id: string | null = null
  //public businessDetail: any
  form!: FormGroup
  officeform!: FormGroup
  Updateofficeform!: FormGroup
  currentStep = 1
  steps = [1, 2, 3] // Steps for the form
  public userList: any = []
  public businessList: any = []
  public officeList: any = []
  public employeeList: any = []
  public departmentList: any = []
  public designationList: any = []
  public totalCount = 0
  public currentPage = 1
  public pageLimit = 10
  public search = ''
  public order = 'desc'
  public isArchived = false
  // public imageURL: string = "../../../../assets/hrmsassets/img/icons/profile-upload-img.svg";
  imageURL: string | ArrayBuffer | null =
    '../../../../assets/hrmsassets/img/icons/profile-upload-img.svg'
  public defaultImg = '../../../../assets/img/logo/logo-small.webp'

  // imagePath: File;
  public imagePath: any
  public apiEndpoint = environment.apiBaseUrl
  fieldRejections = []
  user: any

  public createdAt: any
  public updatedAt: any
  companyCity: any
  cityList: any = []
  stateList: any
  businessState: any
  countryList: any = []
  //employeeCountry: any
  public userId!: string
  NewofficeId!: string
  officeId: any
  officeData: any
  officeState: any
  officeCity: any
  officeDetail: any
  pageLastRecord = 0
  businessImages: { [key: string]: string } = {} // Ensure this is defined correctly
  employees$!: Observable<User[]>
  totalCount$!: Observable<number>
  status = false

  constructor(
    private __route: ActivatedRoute,
    private _businessOwnerService: BusinessOwnerService,
    private _businessService: BusinessService,
    private authService: AuthService,
    private officeService: OfficeService,
    private userService: UserService, //user
    //public datePipe: DatePipe,
    public countryService: CountryService,
    public stateService: StateService,
    public cityService: CityService,
    private location: Location
  ) {
    this.employees$ = this.store.select(selectAllUsers)
    this.totalCount$ = this.store.select(selectTotalCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )
  }

  ngOnInit(): void {
    // Initialize the form with validation
    this.form = this.fb.group({
      ownerInfoForm: this.fb.group({
        ownerId: ['', Validators.required]
      }),
      companyInfoForm: this.fb.group({
        businessName: ['', [Validators.required, Validators.maxLength(100)]],
        website: ['', [this.conditionalUrlValidator()]] // Apply custom validator
      }),
      addressInfoForm: this.fb.group({
        address: ['', Validators.required],
        cityId: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        state_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        country_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        zipCode: ['', Validators.required]
      }),
      socialInfoForm: this.fb.group({
        referenceIdFacebook: [
          '',
          [
            Validators.required,
            Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
          ]
        ],
        referenceIdTwitter: [
          '',
          [
            Validators.required,
            Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
          ]
        ],
        referenceIdLinkedIn: [
          '',
          [
            Validators.required,
            Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
          ]
        ],
        referenceIdSkype: [
          '',
          [
            Validators.required,
            Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
          ]
        ],
        referenceIdWhatsapp: [
          '',
          [
            Validators.required,
            Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
          ]
        ],
        referenceIdInstagram: [
          '',
          [
            Validators.required,
            Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
          ]
        ]
      })
    })

    //office form
    this.officeform = this.fb.group({
      companyInfoForm: this.fb.group(
        {
          // firstName: ['', Validators.required],
          // email: ['', [Validators.required, Validators.email]],
          // personalEmail: ['', this.conditionalEmailValidator()],
          // phone: ['', [Validators.required, this.phoneNumberValidator()]],
          // personalPhone: ['', this.conditionalPhoneValidator()],
          // password: ['', [Validators.required, Validators.minLength(6)]],
          // cnfpassword: [null, [Validators.required]],
          officeName: ['', [Validators.required, Validators.maxLength(100)]]
        }
        // {
        //   validators: this.passwordMatchValidator,

        // }
      ),
      addressInfoForm: this.fb.group({
        address: ['', Validators.required],
        cityId: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        state_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        country_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        zipCode: ['', Validators.required]
      })
    })

    this.Updateofficeform = this.fb.group({
      companyInfoForm: this.fb.group({
        // firstName: ['', Validators.required],
        // email: ['', [Validators.required, Validators.email]],
        // personalEmail: ['', this.conditionalEmailValidator()],
        // phone: ['', [Validators.required, this.phoneNumberValidator()]],
        // personalPhone: ['', this.conditionalPhoneValidator()]
        officeName: ['', [Validators.required, Validators.maxLength(100)]]
      }),
      addressInfoForm: this.fb.group({
        address: ['', Validators.required],
        cityId: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        state_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        country_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        zipCode: ['', Validators.required]
      })
    })

    // this.getBusinessOwnerList();

    //let currentDateTime = this.datePipe.transform(new Date(), 'MM/dd/yyyy h:mm:ss')
    //let currentTime = this.datePipe.transform(new Date(), 'h:mm:ss')

    // Subscribe to the user observable to get the latest user data
    //this.__adminUserService.user$.subscribe(user => {
    //  this.user = user
    //  // console.log('user', this.user);
    //})
    //userService

    // this.__route.paramMap.subscribe(params => {
    //   this.id = atob(params.get('id') || '');
    //   if (this.id) {
    //     this.__adminUserService.get(this.id).subscribe({
    //       next: emp => {
    //         this.employee = emp;
    //         console.log('employee', this.employee)
    //       },
    //       error: err => {
    //         console.error(err);
    //         this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {})
    //       }
    //     })
    //   }
    // })
    //TODO: Remove default id
    this.id = this.__route.snapshot.paramMap.get('id') ?? 'fc02c827-19e6-4480-b10d-da6fc8653fa6'

    // this.setBusinessDetail();
    this.setOfficeDetail()
    this.getCountryList()
    // this.getOfficeList();
    this.getEmployeeList()

    this.employees$
      .pipe(
        distinctUntilChanged(), // don't re-trigger unnecessarily
        tap(employees => {
          this.employeeList = employees // UI renders immediately
        }),
        map(employees => employees.map(e => e.picture).filter((p): p is string => !!p))
      )
      .subscribe()

    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })

    this.employees$.subscribe(employees => {
      employees.forEach(emp => {
        if (emp.picture && !this.businessImages[emp.picture]) {
          this.businessImage(emp.picture)
        }
      })
    })
  }

  // Method to update validators based on the picture's current value

  setOfficeDetail() {
    if (this.id) {
      this.officeService.getOfficeById(this.id).subscribe({
        next: (officeInfo: unknown) => {
          this.officeDetail = officeInfo
          this.userId = this.officeDetail.userId
          const create = new Date(this.officeDetail.createdAt)
          const update = new Date(this.officeDetail.updatedAt)
          this.createdAt = create
          this.updatedAt = update
          this.form
            ?.get('companyInfoForm')
            ?.get('businessName')
            ?.setValue(this.officeDetail.officeName)

          this.form?.get('addressInfoForm')?.get('address')?.setValue(this.officeDetail.address)
          this.form
            ?.get('addressInfoForm')
            ?.get('country_id')
            ?.setValue(this.officeDetail.city.country_id)
          this.form
            ?.get('addressInfoForm')
            ?.get('state_id')
            ?.setValue(this.officeDetail.city.state_id)
          this.form?.get('addressInfoForm')?.get('cityId')?.setValue(this.officeDetail.cityId)
          //this.getStateList(this.officeDetail.country_id)
          //this.getCityList(this.officeDetail.state_id)
          this.form?.get('addressInfoForm')?.get('zipCode')?.setValue(this.officeDetail.zipCode)
        },
        error: error => {
          this.toastr.error('Error: ' + error.message)
        }
      })
    }
  }

  private updateValidators(control: AbstractControl) {
    if (control.value) {
      control.setValidators([Validators.required, this.validateImage])
    } else {
      control.clearValidators()
    }
    control.updateValueAndValidity()
  }

  // Call this method whenever you change the value of picture
  onPictureChange(file: File) {
    const pictureControl = this.form.get('picture')!
    pictureControl.setValue(file) // Update the value
    this.updateValidators(pictureControl) // Update the validators based on the new value
  }

  onFileChange(event: Event) {
    const target = event.target as HTMLInputElement // Type assertion
    if (target.files && target.files.length > 0) {
      const file = target.files[0]
      this.showPreview(event, 'imageURL')
      this.onPictureChange(file)
    }
  }

  copyContent(email: string) {
    navigator.clipboard
      .writeText(email)
      .then(() => {
        this.toastr.success('SUCCESS', 'Email copied!')
        // console.log('Email copied to clipboard:', email);
        // Optionally, show a success message to the user
      })
      .catch(error => {
        this.toastr.error('Error: ' + error.message)
        // console.error('Could not copy email: ', err);

        // Handle the error if needed
      })
  }

  // Function to check if the current step is valid
  isStepValid(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.form.get('ownerInfoForm')?.valid

      case 2:
        return !!this.form.get('companyInfoForm')?.valid
      // &&
      //        !!this.form.get('email')?.valid &&
      //        !!this.form.get('phoneNumber1')?.valid &&
      //        !!this.form.get('phoneNumber2')?.valid;
      case 3:
        return !!this.form.get('addressInfoForm')?.valid
      // &&
      //        !!this.form.get('city')?.valid &&
      //        !!this.form.get('state')?.valid &&
      //        !!this.form.get('country')?.valid &&
      //        !!this.form.get('zipcode')?.valid;
      case 4:
        return !!this.form.get('socialInfoForm')?.valid
      // &&
      //        !!this.form.get('twitter')?.valid &&
      //        !!this.form.get('linkedin')?.valid &&
      //        !!this.form.get('skype')?.valid &&
      //        !!this.form.get('whatsapp')?.valid &&
      //        !!this.form.get('instagram')?.valid;
      // case 4:
      //   return !!this.form.get('visibility')?.valid &&
      //     !!this.form.get('status')?.valid;
      default:
        return false
    }
  }

  // Function to go to the next step
  goToNextStep(): void {
    if (this.isStepValid()) {
      if (this.currentStep === 1) {
        this.updateBusinessOwner()
      }
      if (this.currentStep === 2) {
        this.updateCompany()
      }
      if (this.currentStep === 3) {
        this.updateCompanyAddress()
      }
      if (this.currentStep === 4) {
        this.updateCompanySocial()
      }
      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  isStepValidOffice(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.officeform.get('companyInfoForm')?.valid

      case 2:
        return !!this.officeform.get('addressInfoForm')?.valid

      default:
        return false
    }
  }

  // Function to go to the next step for office
  goToNextOfficeStep(): void {
    if (this.isStepValidOffice()) {
      if (this.currentStep === 1) {
        this.createOffice()
      }
      if (this.currentStep === 2) {
        this.createOfficeAddress()
      }

      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  isStepValidOfficeupdate(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.Updateofficeform.get('companyInfoForm')?.valid

      case 2:
        return !!this.Updateofficeform.get('addressInfoForm')?.valid

      default:
        return false
    }
  }

  // Function to go to the next step for office
  goToNextOfficeupdateStep(): void {
    if (this.isStepValidOfficeupdate()) {
      if (this.currentStep === 1) {
        this.createOffice()
      }
      if (this.currentStep === 2) {
        this.createOfficeAddress()
      }

      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  stepChange(newStep: number): void {
    if (this.isStepValid() || this.isStepValidOffice() || this.isStepValidOfficeupdate()) {
      this.currentStep = newStep
    }
  }

  // Submit the form
  onSubmit(): void {
    if (this.form.valid) {
      this.updateCompanySocial()
    } else {
      alert('Please fill all required fields!')
    }
  }

  getBusinessOwnerList() {
    this.isArchived = false

    this._businessOwnerService.getAllBusinessOwners(null).subscribe({
      next: response => {
        this.userList = response.rows
      },
      error: error => {
        this.toastr.error('Error: ' + error.message)
      }
    })
  }

  getOfficeList() {
    this.isArchived = false

    this.officeService.getOffices('', this.currentPage, this.pageLimit).subscribe({
      next: response => {
        this.officeList = response.offices
      },
      error: error => {
        this.toastr.error('Error: ' + error.message)
      }
    })
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
      if (control.hasError('pattern')) {
        // Check if it's a URL pattern error for social media fields
        if (controlName.includes('facebook')) {
          return 'Please enter a valid Facebook URL'
        } else if (controlName.includes('twitter')) {
          return 'Please enter a valid Twitter URL'
        } else if (controlName.includes('linkedin')) {
          return 'Please enter a valid LinkedIn URL'
        } else if (controlName.includes('skype')) {
          return 'Please enter a valid Skype username or invite link'
        } else if (controlName.includes('whatsapp')) {
          return 'Please enter a valid WhatsApp link'
        } else if (controlName.includes('instagram')) {
          return 'Please enter a valid Instagram URL'
        } else if (controlName.includes('website')) {
          return 'Please enter a valid website URL'
        } else {
          return 'The entered value is not valid'
        }
      }
    }
    return null // No error
  }

  // Custom validator for file type and size
  validateImage(control: AbstractControl) {
    const file = control.value
    if (file) {
      // const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp',];
      const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
      const maxFileSize = 1024 * 1024 // 1MB
      // Get the file extension by splitting the file name
      const fileExtension = file.substring(file.lastIndexOf('.'))
      if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
        return { invalidFileType: true }
      }

      if (file.size > maxFileSize) {
        return { invalidFileSize: true }
      }
    }

    return null
  }

  showPreview(event: Event, imageid: string) {
    const inputElement = event.target as HTMLInputElement

    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0]

      // Only proceed if the file is an image
      if (file.type.startsWith('image/')) {
        const reader = new FileReader()

        reader.onload = () => {
          // Set the image URL once the reader has loaded the file
          this.imageURL = reader.result as string

          // Set the form control value once the file has been read
          // this.form.get('companyInfoForm')?.get('picture')?.setValue(file);
        }

        reader.readAsDataURL(file)
        // Set the form control value once the file has been read
        this.form.get('companyInfoForm')?.get('picture')?.setValue(file)
      } else {
        console.log('Please select an image file.')
      }
    }
  }

  //pagination
  onPageChange(page: number) {
    // this.currentPage = page
    if (page > 0) {
      this.currentPage = page
      this.getEmployeeList() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  //modal open
  openBusiness(content: unknown) {
    this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })
  }

  //modal close
  onClose() {
    this.modalService.dismissAll()
    // this.setBusinessDetail();
    this.setOfficeDetail()
    this.form.reset()
    this.officeform.reset()
    this.Updateofficeform.reset()
    this.currentStep = 1
    this.officeData = ''
  }

  getCountryList() {
    this.isArchived = false
    // let skip = (this.currentPage * this.pageLimit) - this.pageLimit;
    // let search = (this.search) ? { $or: { email: { $like: `%${this.search}%` }, firstName: { $like: `%${this.search}%` }, lastName: { $like: `%${this.search}%` }, role: { $like: `%Office%` }, phone: { $like: `%${this.search}%` } } } : { role: { $like: `%Office%` } };
    // let search = (this.search) ? { $or: {  } } : {};

    this.countryService.getCountries().subscribe({
      next: (response: { countries: unknown }) => {
        // console.log('business', response.rows )
        this.countryList = []
        this.countryList = response.countries
        //this.employeeCountry = this.countryList.find(
        //  (country: { id: unknown }) => country.id === this.businessDetail.country_id
        //)
      },
      error: (error: { message: string }) => {
        this.toastr.error('Error: ' + error.message)
      }
    })
  }

  getStateList(countryId: string) {
    this.isArchived = false
    //let skip = this.currentPage * this.pageLimit - this.pageLimit
    // let search = (this.search) ? { $or: { email: { $like: `%${this.search}%` }, firstName: { $like: `%${this.search}%` }, lastName: { $like: `%${this.search}%` }, role: { $like: `%Office%` }, phone: { $like: `%${this.search}%` } } } : { role: { $like: `%Office%` } };
    //const search = { country_id: { $like: `%${countryId}%` } }

    this.stateService.getStatesByCountry(countryId).subscribe({
      next: response => {
        // console.log('business', response.rows )
        this.stateList = []
        this.stateList = response
      },
      error: (error: { message: string }) => {
        this.toastr.error('Error: ' + error.message)
      }
    })
  }

  getCityList(stateId: string) {
    this.isArchived = false
    //let skip = this.currentPage * this.pageLimit - this.pageLimit
    // let search = (this.search) ? { $or: { email: { $like: `%${this.search}%` }, firstName: { $like: `%${this.search}%` }, lastName: { $like: `%${this.search}%` }, role: { $like: `%Office%` }, phone: { $like: `%${this.search}%` } } } : { role: { $like: `%Office%` } };
    //const search = { state_id: { $like: `%${stateId}%` } }

    this.cityService.getCitiesByState(stateId).subscribe({
      next: response => {
        // console.log('business', response.rows )
        this.cityList = []
        this.cityList = response
      },
      error: (error: { message: string }) => {
        this.toastr.error('Error: ' + error.message)
      }
    })
  }

  // onChangeStateList(target: EventTarget | null) {
  //   let selectedCountryId = ''
  //   this.isArchived = false
  //   if (target instanceof HTMLSelectElement) {
  //     selectedCountryId = target.value
  //   } else if (this.officeData.country_id) {
  //     selectedCountryId = this.officeData.country_id
  //   }
  //   this.stateService.getStatesByCountry(selectedCountryId).subscribe({
  //     next: response => {
  //       this.stateList = []
  //       this.cityList = []
  //       this.stateList = response
  //     },
  //     error: (error: { message: string }) => {
  //       this.toastr.error('Error: ' + error.message)
  //     }
  //   })
  // }

  onChangeStateList(target: EventTarget | null) {
    let selectedCountryId = ''
    if (target instanceof HTMLSelectElement) {
      selectedCountryId = target.value
    }
    this.stateList = []
    this.cityList = []
    this.Updateofficeform.get('addressInfoForm.state_id')?.reset()
    this.Updateofficeform.get('addressInfoForm.cityId')?.reset()
    if (!selectedCountryId) return
    this.stateService.getStatesByCountry(selectedCountryId).subscribe({
      next: response => {
        this.stateList = response
      },
      error: (error: { message: string }) => {
        this.toastr.error('Error: ' + error.message)
      }
    })
  }

  // onChangeCityList(target: EventTarget | null) {
  //   this.isArchived = false
  //   if (target instanceof HTMLSelectElement) {
  //     const selectedStateId = target.value

  //     this.cityService.getCitiesByState(selectedStateId).subscribe({
  //       next: response => {
  //         // console.log('business', response.rows )
  //         // this.officeList = response.rows;
  //         this.cityList = []
  //         this.cityList = response
  //         // this.totalCount = response.count;
  //       },
  //       error: (error: { message: string }) => {
  //         this.toastr.error('Error: ' + error.message)
  //       }
  //     })
  //   } else if (this.officeData.cityId) {
  //     const selectedStateId = this.officeData.state_id

  //     this.cityService.getCitiesByState(selectedStateId).subscribe({
  //       next: response => {
  //         this.cityList = []
  //         this.cityList = response
  //         this.officeCity = this.cityList.find(
  //           (city: { id: unknown }) => city.id === this.officeData.cityId
  //         )
  //       },
  //       error: (error: { message: string }) => {
  //         this.toastr.error('Error: ' + error.message)
  //       }
  //     })
  //   }
  // }

  onChangeCityList(target: EventTarget | null) {
    let selectedStateId = ''
    if (target instanceof HTMLSelectElement) {
      selectedStateId = target.value
    }
    this.cityList = []
    this.Updateofficeform.get('addressInfoForm.cityId')?.reset()

    // ❗ If "Select State"
    if (!selectedStateId) return

    this.cityService.getCitiesByState(selectedStateId).subscribe({
      next: response => {
        this.cityList = response
      },
      error: (error: { message: string }) => {
        this.toastr.error('Error: ' + error.message)
      }
    })
  }

  updateBusinessOwner() {
    const ownerId = this.form.get('ownerInfoForm')?.get('ownerId')?.value
    // const firstName = this.form.get('companyInfoForm')?.get('firstName')?.value;
    // const email = this.form.get('companyInfoForm')?.get('email')?.value;
    // const phone = this.form.get('companyInfoForm')?.get('phone')?.value;
    // const formData = {
    //   ownerId, firstName, phone, email

    // }
    const businessName = this.form.get('companyInfoForm')?.get('businessName')?.value

    const formData = {
      ownerId,
      businessName
    }
    if (this.id) {
      //this._businessService.businessApi.update(this.id, formData).subscribe({
      //  next: () => {
      //    this.toastr.success(
      //      'SUCCESS',
      //      "Business Entity's owner information updated successfully!"
      //    )
      //  },
      //  error: (error: { message: string }) => {
      //    this.currentStep = 1
      //    this.toastr.error('Error: ' + error.message)
      //  }
      //})
    }
  }

  updateCompany(): void {
    const companyData = this.form.get('companyInfoForm')?.value
    const ownerId = this.form.get('ownerInfoForm')?.get('ownerId')?.value
    const formData = {
      ownerId,
      ...companyData
    }
    if (this.id) {
      //this._businessService.businessApi.update(this.id, formData).subscribe({
      //  next: () => {
      //    this.toastr.success('SUCCESS', "Business Entity's information updated successfully!")
      //  },
      //  error: (error: { message: string }) => {
      //    this.currentStep = 2
      //    this.toastr.error('Error: ' + error.message)
      //  }
      //})
    }
  }

  updateCompanyAddress(): void {
    const address = this.form.get('addressInfoForm')?.value
    const ownerId = this.form.get('ownerInfoForm')?.get('ownerId')?.value
    // const firstName = this.form.get('companyInfoForm')?.get('firstName')?.value;
    // const email = this.form.get('companyInfoForm')?.get('email')?.value;
    // const phone = this.form.get('companyInfoForm')?.get('phone')?.value;
    // const formData = {
    //   ownerId, firstName, email, phone,
    //   ...address
    // }
    const businessName = this.form.get('companyInfoForm')?.get('businessName')?.value

    const formData = {
      ownerId,
      businessName,
      ...address
    }
    //if (this.businessDetail.id) {
    //  this._businessService.businessApi.update(this.businessDetail.id, formData).subscribe({
    //    next: () => {
    //      this.toastr.success(
    //        'SUCCESS',
    //        "Business Entity's address information updated successfully!"
    //      )
    //    },
    //    error: (error: { message: string }) => {
    //      this.currentStep = 3
    //      this.toastr.error('Error: ' + error.message)
    //    }
    //  })
    //}
  }

  updateCompanySocial(): void {
    const social = this.form.get('socialInfoForm')?.value
    // const basic = this.form.get('basicInfoForm')?.value;
    const ownerId = this.form.get('ownerInfoForm')?.get('ownerId')?.value
    const formData = {
      // id: this.userId,
      // firstName: this.form.get('basicInfoForm')?.get('firstName')?.value,
      // email: this.form.get('basicInfoForm')?.get('email')?.value,
      // phone: this.form.get('basicInfoForm')?.get('phone')?.value,
      // role: "Employee",
      businessName: this.form.get('companyInfoForm')?.get('businessName')?.value,
      ownerId,
      ...social
    }

    this.onClose()
  }

  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneNumber = control.value
      // const valid = /^\+\d{1,14}$/.test(phoneNumber); // Adjust the regex as needed
      // const valid = /^\+\d{1,3}[\s()\-]?\d{1,14}([\s()\-]?\d{1,4})*$/.test(phoneNumber);
      // const valid = /^\+\d{1,3} \d{1,14}$/.test(phoneNumber);
      const valid = /^\+\d{1,3}[\s]?\d{1,14}$/.test(phoneNumber)

      return valid ? null : { invalidPhoneNumber: true }
    }
  }

  // Custom validator for ownerpersonalPhone
  conditionalPhoneValidator() {
    return (control: AbstractControl) => {
      if (control.value) {
        // Validate using your phoneNumberValidator if value exists
        return this.phoneNumberValidator()(control)
      }
      return null // No error if value is empty
    }
  }

  // Custom validator for ownerpersonalEmail
  conditionalEmailValidator() {
    return (control: AbstractControl) => {
      if (control.value) {
        // Validate using the email validator if value exists
        return Validators.email(control)
      }
      return null // No error if value is empty
    }
  }

  createOffice() {
    if (this.officeId) {
      const userData = this.Updateofficeform.get('companyInfoForm')?.value
      const { personalEmail, personalPhone, ...rest } = userData
      const userformData = {
        id: this.officeId,
        // role: "Office",
        // businessId: this.id,
        ...rest
      }
      this.officeService.updateOffice(userformData).subscribe({
        next: () => {
          this.getOfficeList()
          this.toastr.success('SUCCESS', "Office's basic information updated successfully!")
        },
        error: (error: { message: string }) => {
          this.currentStep = 1
          this.toastr.error('Error: ' + error.message)
          // alert('Failed to create employee: ' + err.message);
        }
      })
    }
  }

  createOfficeAddress() {
    if (!this.officeId) {
      const officeData = this.officeform.get('addressInfoForm')?.value
      const officeformData = {
        // userId: this.NewofficeId,
        ...officeData
      }
      this.officeService.updateOffice(officeformData).subscribe({
        next: () => {
          this.onClose()
          this.toastr.success('SUCCESS', "Office's address information added successfully!")
        },
        error: (error: { message: string }) => {
          this.currentStep = 2
          this.toastr.error('Error: ' + error.message)
        }
      })
    }
    if (this.officeId) {
      const officeData = this.Updateofficeform.get('addressInfoForm')?.value
      const officeformData = {
        id: this.officeId,
        ...officeData
      }
      this.officeService.updateOffice(officeformData).subscribe({
        next: () => {
          this.onClose()
          this.toastr.success('SUCCESS', "Office's address information updated successfully!")
        },
        error: (error: { message: string }) => {
          this.currentStep = 2
          this.toastr.error('Error: ' + error.message)
          // alert('Failed to create employee: ' + err.message);
        }
      })
    }
  }

  // Custom validator to check if password and cnfpassword match
  passwordMatchValidator(control: AbstractControl): Record<string, boolean> | null {
    const password = control.get('password')?.value
    const cnfpassword = control.get('cnfpassword')?.value

    const ownerpassword = control.get('ownerpassword')?.value
    const ownercnfpassword = control.get('ownercnfpassword')?.value

    if (password !== cnfpassword) {
      return { passwordMismatch: true }
    }

    if (ownerpassword !== ownercnfpassword) {
      return { passwordMismatch: true }
    }

    return null
  }

  async SetupdateOffice(office: Office) {
    // console.log('office data', office)
    this.officeData = office
    this.officeId = office.id

    this.Updateofficeform?.get('companyInfoForm')?.get('officeName')?.setValue(office.officeName)
    this.Updateofficeform?.get('addressInfoForm')?.get('address')?.setValue(office.address)
    this.Updateofficeform?.get('addressInfoForm')
      ?.get('country_id')
      ?.setValue(office.city.country_id)
    await this.getStateList(office.city.country_id.toString())
    this.Updateofficeform?.get('addressInfoForm')?.get('state_id')?.setValue(office.city.state_id)
    await this.getCityList(office.city.state_id.toString())
    this.Updateofficeform?.get('addressInfoForm')?.get('cityId')?.setValue(office.cityId)
    this.Updateofficeform?.get('addressInfoForm')?.get('zipCode')?.setValue(office.zipCode)
  }

  conditionalUrlValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value

      // If the value is empty, return null (no errors)
      if (!value) {
        return null
      }

      // Validate the pattern
      const urlPattern = /^https?:\/\/[a-zA-Z0-9.-]+(?:\.[a-zA-Z]{2,})+(:[0-9]+)?(\/.*)?/
      const valid = urlPattern.test(value)

      return valid ? null : { invalidWebsite: true }
    }
  }

  getEmployeeList() {
    this.isArchived = false
    //const skip = this.currentPage * this.pageLimit - this.pageLimit
    // let search = (this.search) ? { $or: { email: { $like: `%${this.search}%` }, firstName: { $like: `%${this.search}%` }, lastName: { $like: `%${this.search}%` }, phone: { $like: `%${this.search}%` }, role: {$like: 'Employee'} }, $and: { officeId: {$like: `%${this.id}%`}} } : {  officeId: this.id };
    //const search = this.search
    //  ? {
    //      $or: {
    //        email: { $like: `%${this.search}%` },
    //        firstName: { $like: `%${this.search}%` },
    //        lastName: { $like: `%${this.search}%` },
    //        phone: { $like: `%${this.search}%` }
    //      },
    //      $and: { role: { $like: 'Employee' }, officeId: { $like: `%${this.id}%` } }
    //    }
    //  : { role: { $like: 'Employee' }, officeId: { $like: `%${this.id}%` } }
    let params: any = {}
    // if (this.search) {
    //   params = `officeId=${this.id}&firstName=${encodeURIComponent(this.search)}&lastName=${encodeURIComponent(this.search)}&email=${encodeURIComponent(this.search)}`
    // } else {
    //   params = `officeId=${this.id}`
    // }
    if (this.search) {
      // params.firstName = this.firstName
      params.search = this.search
    }

    params.disabled = this.status

    if (this.id) {
      params.officeId = this.id
    }
    // this.userService.getEmployees(params, this.currentPage, this.pageLimit).subscribe({
    //   next: response => {
    //     this.employeeList = response.users
    //     // this.totalCount = response.count;
    //     this.totalCount = response.totalCount
    //     this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
    //     this.employeeList.forEach((emp: User) => {
    //       if (emp.picture && !this.businessImages[emp.picture]) {
    //         this.businessImage(emp.picture)
    //       }
    //     })
    //   },
    //   error: (error: { message: string }) => {
    //     this.toastr.error('Error: ' + error.message)
    //   }
    // })

    this.store.dispatch(
      loadEmployees({
        params: new URLSearchParams(params).toString(),
        page: this.currentPage,
        limit: this.pageLimit
      })
    )
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.getEmployeeList() // Load employees with new page limit
  }

  businessImage(picture: string) {
    const imageUrl = this.apiEndpoint + '/uploads/' + picture // Assuming this is the correct path
    this.authService.getImage(imageUrl).subscribe(
      imageBlob => {
        const objectURL = URL.createObjectURL(imageBlob)
        this.businessImages[picture] = objectURL // Store the object URL
      },
      error => {
        console.error('Error fetching image:', error)
      }
    )
  }

  goBack() {
    this.location.back()
  }

  onImageError(employee: any): void {
    employee.picture = null // fallback triggers initials
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    const firstInitial = firstName?.charAt(0) || ''
    const lastInitial = lastName?.charAt(0) || ''
    return (firstInitial + lastInitial).toUpperCase()
  }

  setCurrentPage() {
    this.currentPage = 1
  }
}
